import React, { useRef } from 'react';
import MainHeaderContainer from 'components/containers/header/MainHeaderContainer';
import MainBanner from 'components/containers/banner/MainBanner';
import MainList from 'components/containers/main/list/MainList';

import { MainInner, MainBannerWrapper } from './style';

export default function MainLayout() {
  const scrollRef = useRef(null);
  return (
    <MainInner ref={scrollRef}>
      <MainHeaderContainer />
      <MainBannerWrapper>
        <MainBanner type={'company'} />
      </MainBannerWrapper>
      <MainList scrollRef={scrollRef} type={'company'}/>
    </MainInner>
  );
}
